<nav class="nav" [ngClass]="{ view: view }" data-tour="general.menu">
  <ul>
    <ng-container class="container-logo">
      <h1
        *ngIf="
          userService.currentUser?.role.skuld &&
          userService.currentUser?.role.units.length == 1
        "
        class="logo"
      >
        <img
          src="../../../../assets/images/iso_logo.svg"
          alt="logo skuld"
          title="logo skuld"
          class="logo"
        />
        <img
          src="../../../../assets/images/letras_skuld.svg"
          alt="logo skuld"
          title="logo skuld"
          class="slide-left slide-right"
        />
      </h1>
      <h1
        *ngIf="
          userService.currentUser?.role.skuld &&
          userService.currentUser?.role.units.length == 1
        "
        class="logo"
      >
        <img
          src="../../../../assets/images/iso_vu.svg"
          alt="logo Vu"
          title="logo Vu"
          class="logo"
        />
        <img
          src="../../../../assets/images/letras_vu.svg"
          alt="logo Vu"
          title="logo Vu"
          class="slide-leftVu slide-rightVu"
        />
      </h1>

      <h1
        *ngIf="
          !userService.currentUser?.role.skuld ||
          userService.currentUser?.role.units.length > 1
        "
        class="logo"
      >
        <img
          src="../../../../assets/images/iso_analytiko.png"
          alt="logo Analytiko"
          title="logo Analytiko"
          class="logo analytikoLogo"
        />
        <img
          src="../../../../assets/images/mono_analytiko.png"
          alt="logo Analytiko"
          title="logo Analytiko"
          class="slide-left slide-right analytikoText"
        />
      </h1>
    </ng-container>
  </ul>
  <ul class="list-items" *ngIf="nav.length > 0">
    <ng-container *ngFor="let item of nav">
      <li
        *ngIf="item.if"
        class="item"
        [ngClass]="{ view: item.view && item.subNav }"
        (click)="(item.click)"
      >
        <a (click)="clickNav(item)" [ngClass]="{ selected: item.active }">
          <!-- <i class="fas fa-{{ item.icon }}"></i> -->
          <img
            src="../../../../assets/iconos/{{ item.icon }}"
            alt=""
            class="images-icon"
          />
          <span class="title-item">{{ item.name }}</span>
          <i class="fas fa-angle-down iconSubNav" *ngIf="item.subNav"></i>
        </a>
        <ul
          class="sub-items"
          *ngIf="item.subNav && item.if"
          [ngClass]="{ view: item.view }"
        >
          <ng-container *ngFor="let subItem of item.subNav">
            <li class="sub-item" *ngIf="subItem.if">
              <a
                (click)="clickNav(subItem)"
                [ngClass]="{ selected: subItem.active }"
              >
                <span class="blackSpan">{{ subItem.name }}</span>
                <i class="fas fa-angle-down" *ngIf="subItem.subNav"></i>
              </a>
              <ul
                class="sub-items two"
                *ngIf="item.subNav && item.if"
                [ngClass]="{ view: subItem.view }"
              >
                <ng-container *ngFor="let subItemTwo of subItem.subNav">
                  <li class="sub-item" *ngIf="subItemTwo.if">
                    <a
                      (click)="clickNav(subItemTwo)"
                      [ngClass]="subItemTwo.subNav ? 'subnav' : ''"
                    >
                      <span>{{ subItemTwo.name }}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>
<button
  type="button"
  class="sidebar-toggle"
  [ngClass]="{ view: view }"
  (click)="toggleSidebar()"
  [attr.aria-label]="view ? 'Cerrar menú' : 'Abrir menú'"
  [attr.aria-expanded]="view"
>
  <i class="fas" [ngClass]="view ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
</button>
